import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {fetchLandlords} from '../actions';
import PaginatedList from './PaginatedList';

class Landlords extends Component {
    render() {
        const {fetchLandlords, landlords, match, location: {search}} = this.props;
        const columns = [{
            title: 'Business Name',
            dataIndex: 'business_name',
            key: 'business_name',
            render: (text, record) => (
                <span>
                    <Link to={{
                        pathname: `${match.url}/${record.id}`,
                        state: {
                            from: search || 'page=1'
                        }
                    }}>{text}</Link>
                </span>
            )
        }, {
            title: 'Address Line 1',
            dataIndex: 'address_line_1',
            key: 'address_line_1'
        }, {
            title: 'Address Line 2',
            dataIndex: 'address_line_2',
            key: 'address_line_2'
        }, {
            title: 'Address Line 3',
            dataIndex: 'address_line_3',
            key: 'address_line_3'
        }, {
            title: 'Postcode',
            dataIndex: 'post_code',
            key: 'post_code'
        }, {
            title: 'Main Contact',
            dataIndex: 'contact_name',
            key: 'contact_name'
        }, {
            title: 'Main Contact Tel.',
            dataIndex: 'phone_number',
            key: 'phone_number'
        }, {
            title: 'Main Contact Email',
            dataIndex: 'email',
            key: 'email'
        }];

        return (
            <PaginatedList
                fetchData={fetchLandlords}
                columns={columns}
                source={landlords}
                {...this.props}
            />
        );
    }
}

function mapStateToProps(state) {
    return {
        loading: state.landlords.isFetching,
        landlords: state.landlords.data,
        meta: state.landlords.meta
    };
}
export default withRouter(connect(mapStateToProps, {fetchLandlords})(Landlords));


// WEBPACK FOOTER //
// ./resources/assets/js/components/Landlords.js